import React from 'react';
import { Card, SkeletonImage } from '@bynder/design-system';
import { IconPlaceholder } from '@bynder/icons';
import { PartialComponent } from 'packages/services/ComponentService';
import { useComponentThumbnail } from '../useComponentThumbnail';

interface Props {
    component: PartialComponent;
}

const ComponentThumbnail = ({ component }: Props) => {
    const { thumbnailUrl, isLoading, error } = useComponentThumbnail(component);

    if (isLoading) {
        return <SkeletonImage />;
    }

    if (error || !thumbnailUrl) {
        return (
            <Card.IconPlaceholder>
                <IconPlaceholder />
            </Card.IconPlaceholder>
        );
    }

    return (
        <Card.Images>
            <Card.Img src={thumbnailUrl} contentResize="fit" />
        </Card.Images>
    );
};

export default ComponentThumbnail;
